import { ACCENT, illustrationA11y, lineStyle } from './static-art';

export function ReceiptCodeIllustration(props: { className?: string; label?: string; ink?: string }) {
	const line = lineStyle(props.ink);
	return (
		<svg
			width="121"
			height="136"
			viewBox="29 61 121 136"
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<path
				d="M30.7739 76.3005C30.7739 76.3005 62.2133 145.836 60.1543 194.473L64.5044 189.795L68.5263 193.559L72.0841 188.918L76.57 191.857L80.7466 187.526L85.0779 190.156L90.1825 186.134L95.1325 188.454L100.392 183.968L104.568 187.062L109.054 182.731L114.468 185.979L117.253 181.648L123.595 184.123L127.926 179.328L132.722 182.421L136.434 178.09L141.229 181.493L143.704 176.853L148.036 179.482C148.036 179.482 138.888 89.4558 106.717 62.4955L105.057 67.5778L99.0633 64.3294L96.8857 69.3103L90.571 65.3486L87.1661 70.9466L80.5747 67.4249L77.6013 73.1071L70.7916 69.0697L68.9302 74.7691L63.0882 70.7145L60.9294 75.943L55.151 71.4175L52.6313 77.1788L46.1189 72.5914L44.7096 78.7428L38.1336 73.8117L37.1746 80.4272L30.7705 76.3005H30.7739Z"
				{...line}
			/>
			<path
				d="M77.9989 134.097L69.9294 135.582C67.8617 135.962 65.8353 134.745 65.1976 132.742L62.3205 123.685C61.5487 121.253 63.1197 118.704 65.6376 118.302L73.7966 116.997C75.8401 116.67 77.815 117.892 78.4355 119.867L81.225 128.745C81.9761 131.135 80.4653 133.645 77.9989 134.099V134.097Z"
				fill={ACCENT}
			/>
			<path
				d="M99.2508 129.839L91.1813 131.324C89.1137 131.704 87.0873 130.487 86.4496 128.485L83.5724 119.427C82.8007 116.995 84.3716 114.446 86.8896 114.044L95.0485 112.74C97.0921 112.413 99.0669 113.635 99.6874 115.61L102.477 124.487C103.228 126.878 101.717 129.387 99.2508 129.841V129.839Z"
				fill={ACCENT}
			/>
			<path d="M69.4219 130.831L73.9817 121.263" {...line} />
			<path d="M67.7207 122.748L75.9827 129.485" {...line} />
			<path d="M67.1934 126.73L76.3251 124.955" {...line} />
			<path d="M90.6748 126.574L95.2346 117.006" {...line} />
			<path d="M88.9727 118.491L97.2347 125.228" {...line} />
			<path d="M88.4453 122.473L97.5788 120.697" {...line} />
			<path
				d="M120.504 125.582L112.434 127.067C110.367 127.447 108.34 126.23 107.703 124.228L104.825 115.17C104.054 112.738 105.625 110.189 108.143 109.787L116.301 108.482C118.345 108.156 120.32 109.378 120.94 111.353L123.73 120.23C124.481 122.621 122.97 125.13 120.504 125.584V125.582Z"
				fill={ACCENT}
			/>
			<path d="M112.087 122.342L116.647 112.772" {...line} />
			<path d="M110.386 114.257L118.648 120.995" {...line} />
			<path d="M109.857 118.24L118.991 116.464" {...line} />
		</svg>
	);
}
